module.exports = {
          srcSet: "/_next/static/images/home-teaser4-260-2b489aaf12ad72b782f1a49fdd817e9c.jpg"+" 260w",
          images:[ {path: "/_next/static/images/home-teaser4-260-2b489aaf12ad72b782f1a49fdd817e9c.jpg",width: 260,height: 260}],
          src: "/_next/static/images/home-teaser4-260-2b489aaf12ad72b782f1a49fdd817e9c.jpg",
          toString:function(){return "/_next/static/images/home-teaser4-260-2b489aaf12ad72b782f1a49fdd817e9c.jpg"},
          
          width: 260,
          height: 260
        }